"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const util_rx_1 = require("./util_rx");
class BaseAnimation {
    // eslint-disable-next-line no-useless-constructor
    constructor(valueTo, t = 0) {
        this.valueTo = valueTo;
        this.t = t;
    }
    // ---- IAnimation interface
    map(mapper) {
        return new BaseAnimation((x) => mapper(this.valueTo(x)), this.t);
    }
    multi(other) {
        return new MultiAnimation(this, other);
    }
}
exports.BaseAnimation = BaseAnimation;
// ---- Convenience
BaseAnimation.NULL = new BaseAnimation((x) => x, 0);
class MultiAnimation {
    constructor(...animations) {
        this.animations = animations;
    }
    // ---- IAnimation interface
    get valueTo() {
        return (x0) => this.animations.reduce((x, a) => a.valueTo(x), x0);
    }
    get t() { return this.animations.reduce((t, a) => t + a.t, 0); }
    map(mapper) {
        return new MultiAnimation(...this.animations.map(a => a.map(mapper)));
    }
}
exports.MultiAnimation = MultiAnimation;
class Animatorer {
    // ---- Lifecycle
    constructor(xInitial, scheduler = rxjs_1.asyncScheduler) {
        this.scheduler = scheduler;
        // ---- Input Animations
        this.animation$ = new rxjs_1.Subject();
        this.output$ = new rxjs_1.BehaviorSubject([xInitial, BaseAnimation.NULL]);
        this.value$ = new rxjs_1.BehaviorSubject(xInitial);
        // ---- This enqueues-out MultiAnimations based on their duration
        function enqueueMulti(animation) {
            return (animation instanceof MultiAnimation) ?
                // If multi, break it out enqueued (i.e. spaced out by duration)
                rxjs_1.of(...animation.animations).pipe(util_rx_1.enqueue(a => a.t, scheduler))
                // Otherwise just send out individually
                : rxjs_1.of(animation).pipe(util_rx_1.extend(animation.t, scheduler));
        }
        // ----- Calculates the sequence of initial values for the animations,
        //       and emits pairs [ initial value, animation ].
        //
        function rollAnimations(x0, animations) {
            const x$ = animations.pipe(operators_1.scan((xPrev, animation) => animation.valueTo(xPrev), x0), operators_1.startWith(x0));
            return rxjs_1.zip(x$, animations);
        }
        // ----- Produce output$
        rollAnimations(xInitial, this.animation$).pipe(
        // Sub-animations if MultiAnimation
        operators_1.switchMap(([xBase, animation]) => rollAnimations(xBase, enqueueMulti(animation)))).subscribe(this.output$);
        // ---- Produce value$
        this.output$.pipe(operators_1.map(([x, animation]) => animation.valueTo(x))).subscribe(this.value$);
    }
}
exports.Animatorer = Animatorer;
